"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealerCountries = {
    usa: 1,
    canada: 2,
    unitedKingdom: 3,
    france: 4
};
